import externalLinksData from '../../external-links.json';

export interface ExternalLinks {
  socialMedia: {
    linkedin: string;
    github: string;
    telegram: string;
    email: string;
    medium: string;
    threads: string;
    x: string;
  };
  projects: {
    intelliguard: {
      demo: string;
      github: string;
    };
    '2vault': {
      demo: string;
      github: string;
    };
  };
  usernames: {
    github: string;
  };
}

export const externalLinks: ExternalLinks = externalLinksData;

// Helper functions for commonly used links
export const getSocialMediaLink = (platform: keyof ExternalLinks['socialMedia']) => {
  return externalLinks.socialMedia[platform];
};

export const getProjectLink = (projectName: keyof ExternalLinks['projects'], type: 'demo' | 'github') => {
  return externalLinks.projects[projectName]?.[type];
};

export const getUsername = (platform: keyof ExternalLinks['usernames']) => {
  return externalLinks.usernames[platform];
}; 